<template>
  <div class="the-hot">
    <div class="user-center" style="display: none">
      <img src="../assets/img/index/user2.png" alt="">
      个人中心
      <i class="ri-arrow-right-double-line"></i>
    </div>
    <div class="item-block">
      <div class="name">对话设置</div>

      <!-- 语言设置 -->
      <div class="item-line" v-if="openLangSwitch">
        <div class="left-part">
          <i class="ri-global-line"></i>
          语言设置
        </div>
        <div class="right-part">
          <el-dropdown @command="handleLanguageCommand">
            <span class="el-dropdown-link">
              {{ language }}
              <i class="ri-arrow-right-s-line"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="zh-CN">中文</el-dropdown-item>
              <el-dropdown-item command="en">英文</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>

      <!-- 语音播报 -->
      <div class="item-line">
        <div class="left-part">
          <i class="ri-volume-up-line"></i>
          语音播报
        </div>
        <div class="right-part">
          <el-switch
            v-model="yuyinvalue"
            active-color="#13ce66"
            inactive-color="#C2C5CC">
          </el-switch>
        </div>
      </div>
    </div>
    <div class="item-block">
      <div class="name">通用设置</div>

      <!-- 切换主题 -->
      <div class="item-line" style="display: none">
        <div class="left-part">
          <i class="ri-t-shirt-line"></i>
          主题
        </div>
        <div class="right-part">
          <el-dropdown @command="handleThemeCommand">
            <span class="el-dropdown-link">
              {{ theme }}
              <i class="ri-arrow-right-s-line"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="light">浅色</el-dropdown-item>
              <el-dropdown-item command="dark">深色</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>

      <!-- 字号大小 -->
      <div class="item-line" style="display: none">
        <div class="left-part">
          <i class="ri-text-snippet"></i>
          字号大小
        </div>
        <div class="right-part">
          <el-dropdown @command="handleFontSizeCommand">
            <span class="el-dropdown-link">
              {{ fontSize }}
              <i class="ri-arrow-right-s-line"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="大">大</el-dropdown-item>
              <el-dropdown-item command="标准">标准</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>

      <!-- 长者版 -->
      <div class="item-line">
        <div class="left-part">
          <img src="../assets/img/index/elder.svg" alt="">
          <!-- <i class="ri-volume-up-line"></i> -->
          长者版
        </div>
        <div class="right-part">
          <el-switch
            v-model="olderValue"
            active-color="#13ce66"
            inactive-color="#C2C5CC">
          </el-switch>
        </div>
      </div>

      <!-- 无障碍 -->
      <div class="item-line" style="display: none">
        <div class="left-part">
          <i class="ri-wheelchair-line"></i>
          无障碍
        </div>
        <div class="right-part">
          <el-switch
            v-model="wheelValue"
            active-color="#13ce66"
            inactive-color="#C2C5CC">
          </el-switch>
        </div>
      </div>
    </div>
    <div class="item-block">
      <div class="name">其他</div>
      <div class="item-line" style="display: none">
        <div class="left-part">
          <i class="ri-signpost-line"></i>
          新手
        </div>
        <div class="right-part">
          <span>
            <i class="ri-arrow-right-s-line"></i>
          </span>
        </div>
      </div>
      <div class="item-line">
        <div class="left-part">
          <i class="ri-question-line"></i>
          帮助
        </div>
        <div class="right-part">
          <span>
            <i class="ri-arrow-right-s-line"></i>
          </span>
        </div>
      </div>
      <div class="item-line">
        <div class="left-part">
          <i class="ri-file-text-line"></i>
          声明
        </div>
        <div class="right-part">
          <span>
            <i class="ri-arrow-right-s-line"></i>
          </span>
        </div>
      </div>
      <div class="item-line" style="display: none">
        <div class="left-part">
          <i class="ri-file-user-line"></i>
          协议
        </div>
        <div class="right-part">
          <span>
            <i class="ri-arrow-right-s-line"></i>
          </span>
        </div>
      </div>
    </div>
    <div class="item-block exitButton" style="display: none">
      退出登录
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "the-history",
  mixins: [],
  props: {
    list: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  components: {},
  filters: {
    formatDateFiled (value) {
      const dist = {
        'today': '今天',
        'yesterday': '昨天',
        'last30day': '30天内',
        'out30day': '30天外'
      }
      return dist[value]
    }
  },
  computed: {
    ...mapState({
      // 主题
      currentThemeStyle: (state) => state.business.sysConfig.theme || 'light',
      // 开启语言切换
      openLangSwitch: (state) => state.business.sysConfig.openLangSwitch || false,
    })
  },
  data() {
    return {
      language:'中文',
      theme:'跟随系统',
      fontSize:'标准',
      yuyinvalue:false,
      olderValue:false,
      wheelValue:false,
      // currentThemeStyle: this.$store.state.style.systemStyle.theme,
    }
  },
  watch:{
    olderValue(newval){
      if(newval){
        this.$emit("changeFontOld")
      }else{
        this.$emit("changeFontOld")
      }
    },
    currentThemeStyle (newValue) {
      this.$store.commit('style/updateTheme', newValue)
    },
  },
  methods: {
    handleLanguageCommand(command) {
      this.language = command
      this.changeAppLanguage(command)
    },
    handleThemeCommand(command) {
      this.theme = command
      this.currentThemeStyle = command
    },
    handleFontSizeCommand(command) {
      this.fontSize = command
    },
    changeAppLanguage(language) {
      const that = this
      that.$store.dispatch('app/setLanguage', language)
      that.$i18n.locale = language
    },
  },
  mounted() { },
}
</script>

<style lang="scss" scoped>
@import '~@/assets/css/_var.scss';

.the-hot {
  padding: 20px 16px 0 16px;
  background: #F4F4F4;
  height: 100%;
  .user-center{
    display: flex;
    align-items: center;
    gap: 8px;
    padding-left: 10px;
    margin-top: 50px;
    margin-left: 5px;
    img{
      width: 28px;
      height: 28px;
    }
  }
  .item-block{
    gap: 8px;
    width: 100%;
    margin-top: 16px;
    border-radius: 8px;
    padding: 16px 12px;
    background: #FFFFFF;
    .name{
      font-family: PingFang SC;
      font-weight: 400;
      font-size: 14px;
      line-height: 100%;
      letter-spacing: 0px;
      color: #868997;
    }
    .item-line{
      margin-top: 16px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 15px;
      color: #42444D;
      .left-part{
        align-items: center;
        display: flex;
        gap: 3px;
        img{
          width: 16px;
          height: 16px;
        }
      }
      .right-part{
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 12px;
        line-height: 100%;
        letter-spacing: 0px;
        color: #868997;

      }
    }
    &.exitButton{
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}

::v-deep .session-item__del {
  color: #e53535;
  &:hover {
    color: #e53535;
    background: rgba(184, 92, 92, 0.16);
  }
}

</style>
